import { IAppState } from '@mafc/common';
import { deleteCartEntry } from '../redux/actions/updateQuantity.action';
import { useDispatch, useSelector } from 'react-redux';
import { INewCartEntry } from '../ICart';

const useOOSItem = (entry: INewCartEntry) => {
  const dispatch = useDispatch();
  const { sessionArea, newCart } = useSelector((state: IAppState) => ({
    sessionArea: state.sessionArea,
    newCart: state.newCart,
  }));

  const { offerId, entryNumber, intent } = entry;

  const deleteHandler = () => {
    deleteCartEntry(
      dispatch,
      {
        oldCartState: newCart,
        cartEntryNumber: entryNumber,
        offerId,
        qty: 0,
        isNewC4Journey: true,
        intent,
        isOOS: true,
      },
      sessionArea
    );
  };

  return {
    deleteHandler,
  };
};

export default useOOSItem;
